import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectUserAlert } from '../../redux/user/user.selectors';
import { setAlertMessage } from '../../redux/user/user.actions';

import { WARNING } from '../../SVGs/svg.imports.js';

const AlertBox = ({ alertMessage, setAlertMessage }) => {

  /**
   * Respond to clicks on the popup close button
   *
   * @param {Click Event} evt Event that triggered the click
   *
   * @returns void
   */
  const onCloseButtonClick = (evt) => {
    evt.preventDefault();

    // Clear the alert message to close the popup
    setAlertMessage("");
  };

  if (alertMessage !== "") {
    return (
      <div className="station-map-alert__wrapper is-active" role="alert" aria-live="polite">
        <aside className="station-map-alert__container">
          <div className="nsw-notification nsw-notification--warning">
            <WARNING />
            <div className="nsw-notification__content">
              <span className="nsw-notification__title">Notice</span>
              <p>
                {alertMessage}
              </p>
            </div>
            <button onClick={onCloseButtonClick} className="station-map-alert__close-button"><span className="station-map-alert__close-bar"></span><span className="station-map-alert__close-bar"></span><span className="visuallyhidden">Close this popup</span></button>
          </div>
        </aside>
      </div>
    );
  } else {
    return null;
  }
};

AlertBox.propTypes = {
  "alertMessage": PropTypes.string,
  "setAlertMessage": PropTypes.oneOfType( [PropTypes.string, PropTypes.func] )
};

const mapStateToProps = (state) => {
  return {
    "alertMessage": selectUserAlert(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    "setAlertMessage": message => dispatch(setAlertMessage(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertBox);